
import React, { useEffect, useState } from 'react'
import { Typography, Button, Card, CardContent, CardActions, CircularProgress } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { isAuthenticated } from '../../Helpers/authHelper.js'
import { useAuth } from '../../Context Api/AuthContext'


const ErrorHandler = ({ errors: errorsProp, onRetry, onRefresh = () => window.location.reload() }) => {

    const { logout } = useAuth()
    const navigate = useNavigate()
    const [countdown, setCountdown] = useState(5)

    const isloggedIn = isAuthenticated()
    const errors = Array.isArray(errorsProp) ? errorsProp : [errorsProp].filter(Boolean)
    const hasUnauthorizedError = errors.some(error => error.status === 401)
    useEffect(() => {
        const hasUnauthorizedError = errors.some(error => error.status === 401)
        if (hasUnauthorizedError && !isloggedIn) {
            const timer = setInterval(() => {
                setCountdown((prevCountdown) => {
                    if (prevCountdown <= 1) {
                        clearInterval(timer)
                        navigate('/login')
                        return 0
                    }
                    return prevCountdown - 1
                })
            }, 1000)

            return () => clearInterval(timer)
        }
    }, [errors, navigate])



    if (!errors.length) return null

    const handleLoginRedirect = () => {
        logout()
        // navigate('/login')
    }

    const handleDashboardRedirect = () => {
        navigate('/modules')
    }

    const renderErrorMessages = () => {
        return errors.map((error, index) => (
            <Typography key={index} variant="body2" color="error" gutterBottom>


                {error?.response?.data?.message || ''}
            </Typography>
        ))
    }



    const handleGoBack = () => {
        navigate(-1)
    }

    return (
        <Card variant="outlined" sx={{width:"500px", margin: 'auto', mt: 4 }}>
            <CardContent>
                <Typography variant="h5" component="div" gutterBottom color="error">
                    {/* Error Occurred */} Alert
                </Typography>
                {renderErrorMessages()}

                {hasUnauthorizedError && !isloggedIn && (
                    <Typography variant="body2" sx={{ mt: 2 }}>
                        Redirecting to login in {countdown} seconds...
                    </Typography>
                )}
            </CardContent>
            
            <CardActions sx={{ justifyContent: 'center', flexWrap: '', gap: 1, p: 2 }}>
                {hasUnauthorizedError && !isloggedIn ?
                    (<Button
                        variant="contained"
                        color="primary"
                        onClick={handleLoginRedirect}
                        startIcon={<CircularProgress size={16} color="inherit" />}
                    >
                        Login Now
                    </Button>)
                    : (
                        <>
                            <Button variant="outlined" color="primary" onClick={handleDashboardRedirect}>
                                Go to Dashboard
                            </Button>
                           {/*  <Button variant="outlined" color="secondary" onClick={handleGoBack}>
                                Go Back
                            </Button> */}
                            <Button variant="contained" color="primary" onClick={onRetry}>
                                Retry
                            </Button>
                            <Button variant="contained" color="secondary" onClick={onRefresh}>
                                Refresh Page
                            </Button>
                        </>
                    )}
            </CardActions>
        </Card>
    )
}

export default ErrorHandler